import axiosInstance from "./api_helper";

const refundService = {
    search: async ({ query = '', page = 0, size = 10 }) => {
        return axiosInstance.get('/api/refunds/search', {
            params: { query, page, size }
        });
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/refunds/${id}`);
    },
    save: async (refund) => {
        return axiosInstance.post(`/api/refunds`, JSON.stringify(refund));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/refunds/${payload.id}`, JSON.stringify(payload.refund));
    },

};
export default refundService;
